"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 12 14';

var Download = function Download() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M10.41255,13.7032519 L0.55755,13.7032519 C0.24955,13.7032519 5e-05,13.4445111 5e-05,13.1251037 C5e-05,12.8056963 0.24955,12.5469556 0.55755,12.5469556 L10.41255,12.5469556 C10.72005,12.5469556 10.97005,12.8056963 10.97005,13.1251037 C10.97005,13.4445111 10.72005,13.7032519 10.41255,13.7032519"
  }), _react["default"].createElement("path", {
    transform: "translate(2, 0.2)",
    d: "M6.3125,7.17411852 C6.0945,6.94804444 5.7415,6.94804444 5.524,7.17411852 L4.0225,8.73122963 L4.0225,0.875155556 C4.0225,0.55522963 3.773,0.296488889 3.465,0.296488889 C3.1565,0.296488889 2.907,0.55522963 2.907,0.875155556 L2.907,8.73122963 L1.4055,7.17411852 C1.1875,6.94804444 0.835,6.94804444 0.617,7.17411852 C0.399,7.40019259 0.399,7.76626667 0.617,7.99182222 L3.07,10.5356741 C3.096,10.562637 3.125,10.5870074 3.156,10.6082667 C3.1685,10.6176 3.1825,10.6233037 3.196,10.6310815 C3.2145,10.6414519 3.232,10.6533778 3.2515,10.6616741 C3.2695,10.6689333 3.288,10.6736 3.3065,10.6793037 C3.323,10.6844889 3.339,10.6907111 3.3555,10.6943407 C3.3915,10.7021185 3.428,10.7057481 3.465,10.7057481 C3.5015,10.7057481 3.538,10.7021185 3.5735,10.6943407 C3.591,10.6907111 3.6065,10.6844889 3.623,10.6793037 C3.6415,10.6736 3.66,10.6689333 3.6775,10.6616741 C3.698,10.6528593 3.7155,10.6414519 3.734,10.6310815 C3.747,10.6233037 3.761,10.6176 3.774,10.6082667 C3.8045,10.5870074 3.8335,10.562637 3.8595,10.5356741 L6.3125,7.99182222 C6.5305,7.76626667 6.5305,7.40019259 6.3125,7.17411852"
  }));
};

var _default = (0, _createSvgIcon["default"])(Download, {
  viewBox: viewBox
});

exports["default"] = _default;